import { formatDate } from "../../utils";

export const ongoingProject = [
    {
        title: 'Project Id',
        dataIndex: 'id',
        key: 'id',
        // render : (id) => id
    },
    {
        title: 'Item',
        dataIndex: 'product',
        key: 'name',
        render : (product) => product?.name

    },
    {
        title: 'Approved Quantity',
        dataIndex: 'approved_quantity',
        key: 'approved_quantity',
    },
    {
        title: 'Request Date',
        // dataIndex: 'item_statuses',
        // key: 'item_statuses',
        dataIndex: 'createdAt',
        key: 'createdAt',
        render : (createdAt) => formatDate(createdAt)
    },
    {
        title: 'Deadline Delivery',
        dataIndex: 'client_expected_delivery_date',
        key: 'deadline',
        render : (client_expected_delivery_date) => formatDate(client_expected_delivery_date)

    },
];


